import useAuthStore from "@repo/core/stores/auth";
import {
  useViewedContentStore,
  ViewableContent
} from "@repo/core/stores/viewedContent";

export const useWelcomeController = () => {
  // Hooks & State
  const { user } = useAuthStore();
  const { hasViewedContent, viewContent } = useViewedContentStore();

  // Handlers
  const handleContinue = () => {
    if (!hasViewedContent(ViewableContent.APP_WELCOME, user?.username)) {
      viewContent(ViewableContent.APP_WELCOME, user?.username);
    }
  };

  // Exports
  return {
    handleContinue
  };
};
